<template>
  <v-btn
    v-scroll="onScroll"
    v-show="fab && hideBtn"
    right
    fab
    dark
    fixed
    bottom
    dense
    small
    color="primary"
    @click="toTop"
    class="ml-2 mt-20"
  >
    <v-icon>mdi-chevron-up</v-icon>
  </v-btn>
</template>
<script>
export default {
  data: () => ({
    fab: false,
    hideBtn: false,
  }),
  watch: {
    $route(val) {
      if (val.path.startsWith("/dashboard/")) {
        this.hideBtn = false;
      } else {
        this.hideBtn = true;
      }
    },
  },

  methods: {
    // Scrooll top
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>
